import { h, render, Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';

import TwoFactorLogin from '../TwoFactorLogin.js';
import Button from '../Button.js';

class TwoFactorDisable extends Component {
  state = {
		verified: false,
    showCode: false,
    buttonDisable2FA: 'initial'
  }
  
  cancel2FADisable = () => {
		route('/security', true);
  }
  
  disable2FAForReal = () => {
    this.setState({ buttonDisable2FA: 'loading' });
    fetch('https://api.hirezstudios.com/acct/twoFactorOptIn', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "notifyBySms": "false", "notifyByEmail": "false", "validationPeriod": "0"}`
				}).then((response) => response.json()).then((response) => {
          this.setState({ buttonDisable2FA: 'initial' });
          if (response.statusCode === 200) {
            route('/security', true);
          } else {
            // TODO: error message to user
          }
        })
  }

	componentDidMount() {
		{/* TODO: Load account data after initial load with ShouldComponentUpdate() to ensure username population for TwoFactorLogin bug */}
	}

	render() {
		const { t } = this.props;
		if (this.state.verified === false) {
			return (
				<div className="view-two-factor">
					<h1>{t('Security')}</h1>
					<TwoFactorLogin userData={this.props.userData} callback={() => this.setState({ verified: true })} />
				</div>
			);
		}
		return (
			<div className="view-two-factor">
				<h1>{t('Security - Disable Two Factor Authentication')}</h1>
				<p>{t('Disable two factor authentication on this account?')}</p>
				<div className="buttons-wrapper save-settings">
					<Button
						color="blue"
						copy={t('Disable')}
						state={this.state.buttonDisable2FA}
						onClick={this.disable2FAForReal}
					/>
					<Button
						copy={t('Cancel')}
						onClick={this.cancel2FADisable}
					/>
        </div>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(TwoFactorDisable);


// WEBPACK FOOTER //
// ./components/views/TwoFactorDisable.js